module.exports = {
    login:'로그인',
    taption: '탭션',
    ways_to_use_taption:'탭션 활용방법',
    faq:'자주 묻는 질문',
    pricing:'가격',
    language:'언어 설정',
    product:'상품'
  }
  